import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScanNumberplateDialogComponent } from './components/scan-numberplate-dialog/scan-numberplate-dialog.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { MaterialModule, TransportInfoPanelModule } from '@sdbn/appclient';



@NgModule({
  declarations: [
    ScanNumberplateDialogComponent
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    TransportInfoPanelModule,
    MaterialModule
  ]
})
export class ScanNumberplateModule { }
